import store from "../store";
import axiosUrl from "./axios.service";
import axios from "axios";

const API_URL = axiosUrl.getAxiosUrl();
const AI_ASSISTANT_PROCESSOR_URL =
  process.env.VUE_APP_AI_ASSISTANT_PROCESSOR_URL;

class AIAssistantService {
  getAIAssistantAccessToken() {
    return axios.post(API_URL + "/users/getAIAssistantAccessToken");
  }

  async processPrompt(conversation, locale, noResultsText) {
    const payload = conversation.map((message) => ({
      messageId: message.id,
      role: message.author.id,
      conversationId: store.state.chat.currentConversationId, // CHECK
      timestamp: message.timestamp,
      content: message.text,
    }));

    return await axios
      .post(
        AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/processPrompt",
        {
          messages: payload,
          locale: locale,
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.chat.aiAssistantAccessToken.accessToken}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            store.dispatch("chat/addAssistantMessage", response.data.content);

          } else {
            store.dispatch("chat/addAssistantMessage", noResultsText);
            store.dispatch("chat/startNewConversation");
          }
        }
        // If any error occurs on the server side, we don't pass it along to the client side. Instead, we handle it on the server side and return a response without data.
        // In that case, the current conversation should be closed and a new one started.
        // TODO: on server-side? OR if we keep it here, then analytics log should be inserted!
        else if (response.status === 204) {
          store.dispatch("chat/addAssistantMessage", noResultsText);
          store.dispatch("chat/startNewConversation");
        }
      })
      // If any other error (that couldn't be handled by the server) occurs, we dom't show any explicit error message to the user. Instead, we display a 'no results' message and start a new conversation.
      .catch(() => {
        store.dispatch("chat/addAssistantMessage", noResultsText);
        // TODO: Analytics should be inserted?
        store.dispatch("chat/startNewConversation");
      });
  }
}

export default new AIAssistantService();
